import { FilterType } from '../constants/filter-type';
import { ChipContentOption } from './chip-content-option';

/**
 * Deals with chip content
 */
export class ChipContent {
  /**
   * @constructor
   */
  constructor(
    public icon?: string,
    public value?: string,
    public filterType?: FilterType,
    public isActive?: boolean,
    public iconAfter?: string,
    public options?: ChipContentOption[]
  ) {}
}
